import { Component, OnInit } from '@angular/core';
import {
  faPlus,
  faTrash,
  faSearch
} from "@fortawesome/free-solid-svg-icons";
import { ColoursByModelService } from 'src/app/services/vehicle/colours-by-model.service';
import { ActivatedRoute, Router } from "@angular/router";
import { NotifierService } from "angular-notifier";
import { getEmptyGuid } from "../../../../services/util.service";

@Component({
  selector: 'app-colours-by-model-list',
  templateUrl: './colours-by-model-list.component.html',
  styleUrls: ['./colours-by-model-list.component.css']
})
export class ColoursByModelListComponent implements OnInit {

  searchInput: string = "";
  filteredColoursByModel: any[] = [];
  coloursByModel: any[] = [];

  // Icons imports
  faPlus = faPlus;
  faTrash = faTrash;
  faSearch = faSearch;

  tableHeaders = [
  {
    title: "",
    type: "checkbox",
    id: "checked"
  },
  {
    title: "MODEL",
    type: "link",
    id: "model"
  },
  {
    title: "MODEL CODE",
    type: "data",
    id: "modelCode",
    classes: "max-w-64",
  },
  {
    title: "OCC NUMBER",
    type: "data",
    id: "occNo"
  },
  {
    title: "MODEL GROUP",
    type: "data",
    id: "modelGroup"
  },
  {
    title: "EXTERIOR COLOUR CODE",
    type: "data",
    id: "extColourCode",
    classes: "max-w-64",
  },
  {
    title: "EXTERIOR COLOUR DESCRIPTION",
    type: "data",
    id: "extColourDescription"
  },
  {
    title: "EXTERIOR TYPE",
    type: "data",
    id: "extType"
  },
  {
    title: "INTERIOR COLOUR CODE",
    type: "data",
    id: "intColourCode",
    classes: "max-w-64",
  },
  {
    title: "INTERIOR COLOUR DESCRIPTION",
    type: "data",
    id: "intColourDescription"
  },
  {
    title: "STATUS",
    type: "data",
    id: "status"
  },
  {
    title: "ID",
    type: "hidden",
    id: "colourByModelMasterId"
  }
];

  constructor(
    private coloursByModelService: ColoursByModelService,
    private router: Router,
    private notifier: NotifierService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.getAllColoursByModel();
  }

  getAllColoursByModel(): void {
    this.coloursByModelService.getAllColoursByModel().subscribe(
      (response) => {
        if (response && response.body) {
          this.coloursByModel = response.body.map((item: any) => ({
            checked: false,
            model: item.ModelShortDesc || '',
            modelCode: item.ModelCode || '',
            occNo: item.OccNo || '',
            modelGroup: item.ModelGroup || '',
            extColourCode: item.ExtColourCode || '',
            extColourDescription: item.ExtColourDescription || '',
            extType: item.ExtType || '',
            intColourCode: item.IntColourCode || '',
            intColourDescription: item.IntColourDescription || '',
            status: item.Status === "True" ? "Active" : "Inactive",
            colourByModelMasterId: item.ColourByModelMasterId || ''
          }));
          this.filteredColoursByModel = [...this.coloursByModel];
        } else {
          this.coloursByModel = [];
          this.filteredColoursByModel = [];
        }
      },
      (error) => {
        console.error("Error al obtener los colores por modelo", error);
        this.notifier.notify('error', 'Error loading colours by model.');
      }
    );
  }

  onSearch(searchValue: string): void {
    const term = searchValue.trim().toLowerCase();
    this.filteredColoursByModel = this.coloursByModel.filter((item) =>
      [
        item.model,
        item.modelCode,
        item.occNo,
        item.modelGroup,
        item.extColourCode,
        item.extColourDescription,
        item.extType,
        item.intColourCode,
        item.intColourDescription,
        item.status,
      ].some((value) => String(value ?? '').toLowerCase().includes(term)),
    );
  }

  addEntry(): void {
    const emptyGuid = getEmptyGuid();
    this.router.navigate(["../colours-by-model", emptyGuid], {
      relativeTo: this.route,
    });
  }

  deleteSelectedEntries(): void {
    const selectedItems = this.coloursByModel
      .filter(item => item.checked)
      .map(item => ({
        ColourByModelMasterId: item.colourByModelMasterId || '',
      }));
  
    if (selectedItems.length === 0) {
      this.notifier.notify('error', 'Please select at least one item to delete.');
      return;
    }
  
    if (!confirm('Are you sure you want to delete the selected record(s)?')) return;

    this.coloursByModelService.delete(selectedItems).subscribe({
      next: (response) => {
        if (response?.code === 0) {
          this.notifier.notify('success', response.message || 'Colour by Model successfully deleted.');
          this.getAllColoursByModel();
        } else {
          this.notifier.notify('error', response?.message || 'Error deleting selected items.');
        }
      },
      error: (error) => {
        console.error("Error deleting colours by model:", error);
        this.notifier.notify('error', 'Error deleting selected items.');
      }
    });
  }
  

  openEntry(value: any): void {
    if (value && value.colourByModelMasterId) {
      this.router.navigate(["../colours-by-model", value.colourByModelMasterId], {
        relativeTo: this.route,
      });
    } else {
      console.error("Error: Id not found");
    }
  }
}
